<template>
  <div class="bg-white lg:bg-blue-6">
    <SideAccordionNavTemplate
      id="clientNav"
      :is-collapsable="true"
      :side-nav-accordions="sideNavAccordions"
      :styles="{
        heading: 'mh6 md:text-button1 text-blue-1',
        content: 'paragraph-2 hover:text-blue-1',
        base: '',
        contentIconFill: 'blue-2',
      }"
      @click="emit('click')" />
    <AncillaryLinks v-if="showAncillaryLinks" @click="emit('click')" />
    <div v-if="enableAdviserHomepage" class="w-full mt-8">
      <ContactAdviserMailLink
        class="paragraph-2 p-[10px] text-grey-2 hover:text-blue-1 w-full text-left cursor-pointer" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed, watch } from 'vue'
import SideAccordionNavTemplate from '@/components/NavBar/TopNavBar/SideAccordionNavigation/SideAccordionNavTemplate.vue'
import { FeatureList, useLDFlag } from '@/lib/ldClient.ts'
import { useNavBarStore } from '@/store/pinia/NavBarStore.ts'
import AncillaryLinks from '@/components/CFS/CFSClientConfirmationSteps/AncillaryLinks.vue'
import ContactAdviserMailLink from '@/app/components/public/advisers/ContactAdviserMailLink.vue'

const navRouteStore = useNavBarStore()
const sideNavAccordions = computed(() => navRouteStore.getNavRoutes)
// Activating LaunchDarkly flags - must be done in component
const enableModule2 = useLDFlag('enable-cfs-module-2', false)
const enableModuleNonConcessionalContributions = useLDFlag('enable-cfs-module-2.3', false)
const enableInsuranceModule = useLDFlag('enable-insurance-module', false)
const enableAdviserHomepage = useLDFlag(FeatureList.ENABLE_ADVISER_HOMEPAGE, false)
const showAncillaryLinks = computed(() => navRouteStore.showAncillaryLinks)
const emit = defineEmits(['click'])

const ldFlags = computed(() => {
  return {
    disabledModule2: !enableModule2.value,
    disabledModuleNonConcessionalContributions: !enableModuleNonConcessionalContributions.value,
    disabledInsurance: !enableInsuranceModule.value,
  }
})

watch(
  ldFlags,
  () => {
    navRouteStore.setLDFlags(ldFlags.value)
  },
  { immediate: true, deep: true },
)
</script>

<style scoped></style>
